import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LinkRouter from './LinkRouter';
import ClientProvider from './client';
export default createDemo(import.meta.url, LinkRouter, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/routing/demos/link-router/LinkRouter.tsx",
    "fileName": "LinkRouter.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { Link as RouterLink, MemoryRouter, StaticRouter } from 'react-router';\nimport type { LinkProps as RouterLinkProps } from 'react-router';\nimport Link from '@mui/material/Link';\nimport Box from '@mui/material/Box';\n\nconst LinkBehavior = React.forwardRef<any, Omit<RouterLinkProps, 'to'>>(\n  (props, ref) => (\n    <RouterLink\n      ref={ref}\n      to=\"/material-ui/getting-started/installation/\"\n      {...props}\n    />\n  ),\n);\n\nfunction Router(props: { children?: React.ReactNode }) {\n  const { children } = props;\n  if (typeof window === 'undefined') {\n    return <StaticRouter location=\"/\">{children}</StaticRouter>;\n  }\n\n  return <MemoryRouter>{children}</MemoryRouter>;\n}\n\nexport default function LinkRouter() {\n  return (\n    <Box sx={{ typography: 'body1' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Router>\n        <Link component={RouterLink} to=\"/\">\n          With prop forwarding\n        </Link>\n        <br />\n        <Link component={LinkBehavior}>Without prop forwarding</Link>\n      </Router>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 38,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { Link as RouterLink, MemoryRouter, StaticRouter } from 'react-router';\nimport type { LinkProps as RouterLinkProps } from 'react-router';\nimport Link from '@mui/material/Link';\nimport Box from '@mui/material/Box';\n\nconst LinkBehavior = React.forwardRef<any, Omit<RouterLinkProps, 'to'>>(\n  (props, ref) => (\n    <RouterLink\n      ref={ref}\n      to=\"/material-ui/getting-started/installation/\"\n      {...props}\n    />\n  ),\n);\n\nfunction Router(props: { children?: React.ReactNode }) {\n  const { children } = props;\n  if (typeof window === 'undefined') {\n    return <StaticRouter location=\"/\">{children}</StaticRouter>;\n  }\n\n  return <MemoryRouter>{children}</MemoryRouter>;\n}\n\nexport default function LinkRouter() {\n  return (\n    <Box sx={{ typography: 'body1' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Router>\n        <Link component={RouterLink} to=\"/\">\n          With prop forwarding\n        </Link>\n        <br />\n        <Link component={LinkBehavior}>Without prop forwarding</Link>\n      </Router>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Router"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "component"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "RouterLink"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "to"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            "          With prop forwarding"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 33
            },
            [
              "        <",
              [
                "span",
                "pl-ent",
                "br"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "component"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "LinkBehavior"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Without prop forwarding</",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Router"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 38,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "react",
      "react-router",
      "@mui/material/Link",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
